<template>
    <span>{{ $t("web-rg.settingsView") }}</span>
</template>
